import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { ShiftType } from '@/features/shiftTemplate/domain/enums/ShiftType'

export class ShiftFilterEntity {
  time?: Date[]
  startDateTime?: Date[]
  startDate?: Date[]
  duration?: Date[]
  minSize?: number
  maxSize?: number
  type?: ShiftType
  page?: number
  limit?: number
  region?: RegionMiniEntity
}
